/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Playing_Title_AccentInputs */

const en_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR experience`)
};

const es_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experiencia en el PGA TOUR`)
};

const de_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrung auf der PGA TOUR`)
};

const zh_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美巡赛经历`)
};

const ar_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خبرة في PGA TOUR`)
};

const fr_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`expérience sur le PGA TOUR`)
};

const vi_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kinh nghiệm PGA TOUR`)
};

const sw_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`uzoefu wa PGA TOUR`)
};

const th_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสบการณ์บน PGA TOUR`)
};

const bs_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iskustvo na PGA TOUR-u`)
};

const ja_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGAツアー経験`)
};

const ko_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR 경험`)
};

const pt_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`experiência no PGA TOUR`)
};

const it_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esperienza sul PGA TOUR`)
};

const sv_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erfarenhet från PGA TOUR`)
};

const nl_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR-ervaring`)
};

const da_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erfaring fra PGA TOUR`)
};

const nb_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`erfaring fra PGA TOUR`)
};

const fi_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR -kokemus`)
};

const pl_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`doświadczenie na PGA TOUR`)
};

const ru_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`опыт PGA TOUR`)
};

const tr_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR deneyimi`)
};

const hi_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR का अनुभव`)
};

const id_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pengalaman PGA TOUR`)
};

const ms_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pengalaman PGA TOUR`)
};

const cs_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`zkušenosti z PGA TOUR`)
};

const el_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εμπειρία στο PGA TOUR`)
};

const he_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ניסיון ב-PGA TOUR`)
};

const af_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR-ervaring`)
};

const hu_about_playing_title_accent = /** @type {(inputs: About_Playing_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR-tapasztalat`)
};

/**
* | output |
* | --- |
* | "PGA TOUR experience" |
*
* @param {About_Playing_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_playing_title_accent = /** @type {((inputs?: About_Playing_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Playing_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_playing_title_accent(inputs)
	if (locale === "de") return de_about_playing_title_accent(inputs)
	if (locale === "zh") return zh_about_playing_title_accent(inputs)
	if (locale === "ar") return ar_about_playing_title_accent(inputs)
	if (locale === "fr") return fr_about_playing_title_accent(inputs)
	if (locale === "vi") return vi_about_playing_title_accent(inputs)
	if (locale === "sw") return sw_about_playing_title_accent(inputs)
	if (locale === "th") return th_about_playing_title_accent(inputs)
	if (locale === "bs") return bs_about_playing_title_accent(inputs)
	if (locale === "ja") return ja_about_playing_title_accent(inputs)
	if (locale === "ko") return ko_about_playing_title_accent(inputs)
	if (locale === "pt") return pt_about_playing_title_accent(inputs)
	if (locale === "it") return it_about_playing_title_accent(inputs)
	if (locale === "sv") return sv_about_playing_title_accent(inputs)
	if (locale === "nl") return nl_about_playing_title_accent(inputs)
	if (locale === "da") return da_about_playing_title_accent(inputs)
	if (locale === "nb") return nb_about_playing_title_accent(inputs)
	if (locale === "fi") return fi_about_playing_title_accent(inputs)
	if (locale === "pl") return pl_about_playing_title_accent(inputs)
	if (locale === "ru") return ru_about_playing_title_accent(inputs)
	if (locale === "tr") return tr_about_playing_title_accent(inputs)
	if (locale === "hi") return hi_about_playing_title_accent(inputs)
	if (locale === "id") return id_about_playing_title_accent(inputs)
	if (locale === "ms") return ms_about_playing_title_accent(inputs)
	if (locale === "cs") return cs_about_playing_title_accent(inputs)
	if (locale === "el") return el_about_playing_title_accent(inputs)
	if (locale === "he") return he_about_playing_title_accent(inputs)
	if (locale === "af") return af_about_playing_title_accent(inputs)
	if (locale === "hu") return hu_about_playing_title_accent(inputs)
	return en_about_playing_title_accent(inputs)
});